"use client";

import { useEffect, useState } from "react";

const RESUME_URL = "/assets/DavidPaulRomero_Resume_Aug17.pdf";

const publicSections = [
  { id: "top", label: "Home" },
  { id: "luma", label: "Luma AI" },
  { id: "lightwheel", label: "Lightwheel", compactLabel: "Light" },
  { id: "varjo", label: "Varjo" },
  { id: "videography", label: "Videography", compactLabel: "Video" },
];

const previewSections = [
  ...publicSections.slice(0, 3),
  { id: "vive", label: "HTC VIVE", compactLabel: "VIVE" },
  ...publicSections.slice(3),
];

export function SectionNavigation({ showHtc = false }: { showHtc?: boolean }) {
  const sections = showHtc ? previewSections : publicSections;
  const [activeId, setActiveId] = useState("top");

  useEffect(() => {
    const updateFromHash = () => {
      const id = window.location.hash.slice(1);
      if (sections.some((section) => section.id === id)) setActiveId(id);
    };

    updateFromHash();
    window.addEventListener("hashchange", updateFromHash);

    const observer = new IntersectionObserver(
      (entries) => {
        const current = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (current) setActiveId(current.target.id);
      },
      { rootMargin: "-18% 0px -66%", threshold: [0.01, 0.25, 0.5] },
    );

    sections.forEach(({ id }) => {
      const target = document.getElementById(id);
      if (target) observer.observe(target);
    });

    return () => {
      window.removeEventListener("hashchange", updateFromHash);
      observer.disconnect();
    };
  }, [sections]);

  return (
    <nav className="section-nav" aria-label="Portfolio sections">
      <div>
        {sections.map((section) => (
          <a
            aria-current={activeId === section.id ? "location" : undefined}
            aria-label={section.label}
            href={`#${section.id}`}
            key={section.id}
            onClick={() => setActiveId(section.id)}
          >
            <span aria-hidden="true" className="section-nav-label" data-compact-label={section.compactLabel ?? section.label}>{section.label}</span>
          </a>
        ))}
        <a className="resume-nav-link" href={RESUME_URL} target="_blank" rel="noopener noreferrer">
          Resume
        </a>
        <a aria-label="Let's connect" className="connect-nav-link" href="#connect">
          <span aria-hidden="true" className="section-nav-label" data-compact-label="Connect">Let&apos;s connect</span>
        </a>
      </div>
    </nav>
  );
}
